import { useFlightLoadingDetails } from "@apac/hooks";
import type { FlightExchangeRebookLoadingProps } from "@b2bportal/core-flights/overridable";
import { LoadingScreen } from "@hsbc/portal";

export const FlightExchangeRebookLoading = ({
  isLoading,
  loadingTitle,
}: FlightExchangeRebookLoadingProps) => {
  const { context } = useFlightLoadingDetails();

  return (
    <LoadingScreen
      isLoading={isLoading}
      flightLoadingDetails={context}
      loadingSteps={[{ title: loadingTitle }]}
    />
  );
};
